import { Selector, createSelector } from 'reselect'
import { networkGroup } from './utils'

import {
  IRecord_User,
} from '@kaidam/fc-shared/src/types/schema/user'

import {
  ADMIN_USERS,
} from '@kaidam/fc-shared/src/constants'

import {
  RootState,
} from '../../types/store'

export const loaded: Selector<RootState, boolean> = state => state.auth.loaded
export const data: Selector<RootState, IRecord_User | null> = state => state.auth.data
export const token: Selector<RootState, string> = state => state.auth.token
export const loggingOut: Selector<RootState, boolean> = state => state.auth.loggingOut

export const isAdminUser = createSelector(
  data,
  (user) => {
    if(!user) return false
    return ADMIN_USERS.indexOf(user.email) >= 0
  }
)

export const network = networkGroup('auth', [
  'login',
  'register',
  'resetPassword',
])

export default {
  loaded,
  data,
  token,
  loggingOut,
  isAdminUser,
  network,
}